import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoricalTrendsComponent } from './components/historical-trends-at-a-glance/historical-trends.component';
import { HistoricalTrendsService } from './services/historical-trends.service';
import { HistoricalTrendsRoutingModule } from './historical-trends.routing.module';
import { SharedModule } from '../shared/shared.module';
import { ThirdPartyModule } from '../third-party/third-party.module';
import { HistoricalTrendsInsightsComponent } from './components/historical-trends-insights/historical-trends-insights.component';
import { HistoricalTrendsReportsComponent } from './components/historical-trends-reports/historical-trends-reports.component';
import { HistoricalTrendsTransitionComponent } from './components/historical-trends-transition/historical-trends-transition.component';
import { HistoricalTrendsUpgradeComponent } from './components/historical-trends-upgrade/historical-trends-upgrade.component';
import { HistoricalTrendsInsightOptionComponent } from './components/historical-trends-insight-option/historical-trends-insight-option.component';
import { StreamgraphVolPerLevelComponent } from './components/streamgraph-vol-per-level/streamgraph-vol-per-level.component';
import { HistoricalInsightGeographicComponent } from './components/historical-trends-insights/hist-insights-geo/historical-insights-geographic.component';
import { GeographicMapService } from './services/geographic-map.service';
import { HeadcountTrendsComponent } from './components/headcount-trends/headcount-trends.component';

@NgModule({
    declarations: [
        HistoricalTrendsComponent,
        HistoricalTrendsInsightsComponent,
        HistoricalTrendsReportsComponent,
        HistoricalTrendsTransitionComponent,
        HistoricalTrendsUpgradeComponent,
        HistoricalTrendsInsightOptionComponent,
        StreamgraphVolPerLevelComponent,
        HistoricalInsightGeographicComponent,
        HeadcountTrendsComponent,
    ],
    imports: [CommonModule, HistoricalTrendsRoutingModule, SharedModule, ThirdPartyModule],
    providers: [HistoricalTrendsService, GeographicMapService],
    schemas: [NO_ERRORS_SCHEMA],
})
export class HistoricalTrendsModule {}
